import type Device from "../../models/Device";
import KnxChapterHierachie from "./KnxChapterHierachie";

export interface KnxParameterViewerCache {
  viewer: JSX.Element;
  windowNumber: 1 | 2;
  ownerDocument: Document;
}

/** Records which window created the cached viewer after KNX evaluation. */
export function createKnxParameterViewerCache(
  viewer: JSX.Element | null | undefined,
  ownerWindow: Window,
): KnxParameterViewerCache | undefined {
  if (!viewer) {
    return undefined;
  }

  return {
    viewer,
    windowNumber: ownerWindow.opener ? 2 : 1,
    ownerDocument: ownerWindow.document,
  };
}

/** Reuses the viewer locally or recreates its outer component when changing windows. */
export function getKnxParameterViewerForWindow(
  cache: KnxParameterViewerCache,
  device: Device,
  ownerWindow: Window,
): JSX.Element {
  const windowNumber = ownerWindow.opener ? 2 : 1;
  // A reopened second window has the same number but a new React instance.
  if (cache.windowNumber !== windowNumber || cache.ownerDocument !== ownerWindow.document) {
    cache.viewer = <KnxChapterHierachie device={device} knxChapterItems={device.knxChapters} />;
    cache.windowNumber = windowNumber;
    cache.ownerDocument = ownerWindow.document;
  }

  return cache.viewer;
}
